export default __webpack_public_path__ + "static/start-0d1c107b661f6a2b6a0850692a4c0b8e.png";